import { cn } from "~/v2/utils/cn";

interface MetricColumnProps {
  label: string;
  value: string;
  color?: string;
  isLoading?: boolean;
}

export const MetricColumn = ({
  label,
  value,
  color,
  isLoading,
}: MetricColumnProps) => (
  <div className="flex flex-col items-start gap-y-2">
    <span className="whitespace-nowrap font-medium text-gray-700 text-sm">
      {label}
    </span>
    {isLoading ? (
      <div className="h-4 w-16 animate-pulse rounded bg-gray-200" />
    ) : (
      <span
        className={cn(
          "whitespace-nowrap font-medium font-mono text-sm",
          value !== "$0" ? color || "text-gray-700" : "text-gray-400",
        )}
      >
        {value}
      </span>
    )}
  </div>
);
